import { createRequestActions } from 'store/actionCreators'

export const fetchOrgLabels = createRequestActions('ORG_LABELS/FETCH', () => ({
  request: {
    url: '/labels',
  },
}))

export const createOrgLabel = createRequestActions('ORG_LABELS/CREATE', name => ({
  request: {
    url: '/labels',
    method: 'POST',
    data: { name },
  },
  success: 'New Organization Label successfully created',
}))

export const updateOrgLabel = createRequestActions('ORG_LABELS/UPDATE', ({ id, name }) => ({
  request: {
    url: `/labels/${id}`,
    method: 'PUT',
    data: { name },
  },
  success: 'Organization Label successfully updated',
}))

export const deleteOrgLabel = createRequestActions('ORG_LABELS/DELETE', labelId => ({
  request: {
    url: `/labels/${labelId}`,
    method: 'DELETE',
  },
  labelId,
  success: 'Organization Label successfully deleted',
}))
